import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from '@zones-digital-platform/react-oidc-auth';
import Home from './components/Home';
import Post from './components/Post';
import Edit from './components/Edit';
import PartnerInventory from './components/PartnerInventory';
import ProtectedRoute from './components/ProtectedRoute';

export default function App() {
  const [authConfig, setAuthConfig] = useState(null);
  const [error, setError] = useState(null);
  
  // Fetch authConfig
  useEffect(() => {
    fetch('/api/auth-config')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch auth config');
        }
        return response.json();
      })
      .then((data) => {
        setAuthConfig(data);
      })
      .catch((err) => {
        console.error('Error fetching auth config:', err);
        setError('Failed to load authentication configuration');
      });
  }, []);

  if (error) {
    return (
      <div className="flex items-center justify-center h-screen">
        <span className="text-red-500">Error: {error}</span>
      </div>
    );
  }

  if (!authConfig) {
    return (
      <div className="flex items-center justify-center h-screen">
        <span>Loading...</span>
      </div>
    );
  }

  return (
    <AuthProvider config={authConfig}>
      <div>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/partnerInventory"
              element={
                <ProtectedRoute>
                  <PartnerInventory />
                </ProtectedRoute>
              }
            />
            <Route path="/poview/:id" element={<Post />} />
            <Route path="/edit/:id" element={<Edit />} />
          </Routes>
        </Router>
        <footer className="flex item-center justify-center h-16 bg-z-blue">
          <span className="text-white mt-[10px] font-semibold">
            Build Version 0.9.103
          </span>
        </footer>
      </div>
    </AuthProvider>
  );
}
